module.exports = __webpack_public_path__ + "media/img/landing/b-purple-e2a32128366110c75234bbcf924c39ca.png";